import { motion } from "motion/react";

const animationProps = {
	initial: { opacity: 0, height: 0, width: "100%" },
	animate: { opacity: 1, height: "auto", width: "100%" },
	exit: { opacity: 0, height: 0, width: "100%" },
	transition: { duration: 0.3 },
};

type FadeHeightAnimationProps = {
	children: React.ReactNode;
};

export const FadeHeightAnimation: React.FC<FadeHeightAnimationProps> = ({
	children,
}) => {
	return (
		<motion.div style={{ overflow: "hidden" }} {...animationProps}>
			{children}
		</motion.div>
	);
};
